import {
  getRankingTop,
  getRankingUserId,
  getAnswer,
} from '~/api/generated/api';
import type {
  GetRankingUserId200,
  ModeParameter,
  UserRank,
} from '~/api/generated/model';
import { useLocalstorage } from '~/composables/useLocalstorage';

type TopPageData = {
  score: number | undefined;
  bestScore: number | undefined;
  rankingTop: UserRank[] | null;
  rankingUserId: GetRankingUserId200 | null;
  currentQuestionNumber: number | null;
};

type Args = {
  mode: ModeParameter;
  userId: string;
};
export const useRanking = ({ mode, userId }: Args) => {
  const { STORAGE_KEY, getStorage } = useLocalstorage();
  const score = computed(
    () => getStorage(STORAGE_KEY.SCORE_NORMAL) as number | undefined,
  );
  const bestScore = computed(
    () => getStorage(STORAGE_KEY.OLD_BEST_SCORE_NORMAL) as number | undefined,
  );

  const topPageData = reactive<TopPageData>({
    score: score.value,
    bestScore: bestScore.value,
    rankingTop: null,
    rankingUserId: null,
    currentQuestionNumber: null,
  });

  const setData = async () => {
    const [resGetRankingTop, resGetRankingUserId, resGetAnswer] =
      await Promise.all([
        getRankingTop({ mode, limit: 10 }),
        getRankingUserId({ mode, userId }),
        getAnswer(),
      ]);
    topPageData.rankingTop = resGetRankingTop;
    topPageData.rankingUserId = resGetRankingUserId;
    topPageData.currentQuestionNumber = resGetAnswer;
  };

  return {
    topPageData,
    setData,
  };
};
